var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"ms-doc"},[_c('h3',[_vm._v("README.md")]),_c('article',[_c('h1',[_vm._v("群聊管理系统")])])])])}]

export { render, staticRenderFns }